<template>
	<div>
		<!-- Other holders - credentials -->
		<div slot="headline" class="fs5 lh125 fw7 c1 mb2">
			{{ $t("other_holders") }}
		</div>

		<!-- List of holders -->
		<div v-for="holder in list" :key="holder.id" class="mb2">
			<core-entity-card :entity="holder" :isExpanded="false" />
		</div>

		<!-- Empty state -->
		<j-card v-if="list.length === 0" class="bg5 p2 ta2 fs3">
			{{ $t("errors.no_data") }}
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard/"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard/"

export default {
	components: {
		CoreEntityCard,
		JCard
	},

	props: {
		list: {
			type: Array,
			required: true,
			default: () => []
		}
	}
}
</script>